// src\app\services\authguard\tos-guard.service.ts
import { Injectable } from '@angular/core';
import { Router, UrlTree } from "@angular/router";
import { UserService } from '../user/user.service';
import { Observable, of } from 'rxjs';
import { AuthService } from '../auth/auth.service';

/**
 * TosGuardService checks if the user has accepted the terms of service
 * If they have not accepted them, they are redirected to the TosComponent
 */
@Injectable({
  providedIn: 'root'
})
export class TosGuardService {
  /**
   * TosGuard service constructor
   * 
   * @param _userService User service to verify the terms of service
   * @param _router Router to redirect if necessary
   */
  constructor(
    private _userService: UserService,
    private _authService: AuthService,
    private _router: Router,
  ) { }

  /**
   * Checks if the user has accepted the terms of service
   * 
   * @param route The active route
   * @param state The router state
   * @returns true if the user has accepted the terms, false if not
   */
  public canActivate(): Observable<boolean | UrlTree> {
    // Don't check non-authenticated users
    if (!this._authService.authenticated) {
      return of(true);
    }

    // Don't check if the user service is still loading
    if (this._userService.loading) {
      console.log("[TOS-GUARD]: User service is still loading, waiting for user data");
      return of(false);
    }

    console.log(`[TOS-GUARD]: User is authenticated, checking TOS acceptance (accepted: ${this._userService.tosAccepted})`);
    return of(this._userService.tosAccepted ? true : this._router.parseUrl('tos'));
  }
}